import { useParams } from 'react-router-dom';

export const EditAlert = () => {
	const { alertId } = useParams();
	return <div className={'flex justify-center'}>{alertId || 'No alert'}</div>;
};
